import React,{useEffect, useState} from 'react';
import './menu.css';

function Menu({goPlay, goSelectChapter, goToGallery}) {
  const [step, setStep] = useState( localStorage.getItem('step') === null ? false : localStorage.getItem('step') == 0 ? false: true );
  const [white, setWhite] = useState(1);
  const [index, setIndex] = useState(14);
  useEffect(() => {
    changeWhite(true);
},[]);

  async function go(){
    setIndex(14);
    if(step === false){
      localStorage.setItem('failedGame', 0);
    }
    await changeWhite();
    goPlay();
  }

  async function goNew(){
  localStorage.setItem('step', 0);
  setIndex(14);
  await changeWhite();
  goPlay();
}

  async function goChapter(){
    setIndex(14);
    await changeWhite();
    goSelectChapter();
  }

  async function goGallery(){
    setIndex(14);
    await changeWhite();
    goToGallery();
  }

  function changeWhite(toLow){
    return new Promise((resolve, reject) => {
    if(toLow){
      var op=1;
      change(toLow);
    }else{
      var op=0;
      change();
    }
    function change(toLow){
    if(toLow){
      if(op>0){
        op-=0.03;
      setWhite(op);
      setTimeout(ChangetoLow, 10);
    }else{
      setIndex(0);
      resolve();
      return;
    }
  }else{
    if(op<1){
      op+=0.03;
    setWhite(op);
    setTimeout(change, 10);
  }else{
    resolve();
    return;
  }
  }

  function ChangetoLow(){
     change(true);
  }
  }
  });
  }
return(
<div className='menu'>
<p id="title">NSFW Job</p>
<div className='clickWrap' id='wrap' style={{opacity:white,zIndex:index}}></div>
<h1>Hey there! We are constantly working on updates - they come out regularly on our <span>Patreon</span>! We also post some intel there about the game and upcoming chapters.
<br/>Enjoy gaming</h1>
<div className="bttns">
<div className="button" onClick={go}>{step === false? "START" : "CONTINUE"}</div>
{step && <div className="button" onClick={goNew}>NEW GAME</div>}
<div className="button" onClick={goChapter}>CHAPTERS</div>
<div className="button" onClick={goGallery}>GALLERY</div>
<a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button"><span>SUPPORT US</span>
<div className="boxwrap">
<div className="box">
    <div className="arrow"></div>
  </div></div></div></a>
</div>
</div>
);

}

export default Menu;
